export enum TabNames {
    Samples = 'samples',
    Packs = 'packs',
}
